import styled from 'styled-components';
import { COMMENTS_SIDEBAR_COLLAPSED_WIDTH, COMMENTS_SIDEBAR_EXPANDED_WIDTH } from '../constants';

export const StyledContainer = styled.div`
  width: ${({ isCollapsed }) =>
    isCollapsed ? COMMENTS_SIDEBAR_COLLAPSED_WIDTH : COMMENTS_SIDEBAR_EXPANDED_WIDTH}px;
  border-radius: 4px;
  border: 1px solid #f1f3f5;
  background: #fff;
  padding: 16px;
  max-height: calc(100vh - 258px);
  overflow: auto;
  transition: width 300ms ease;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #495057;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 15px;
  }

  button {
    padding: 0;
    svg {
      transform: ${({ isCollapsed }) => (!isCollapsed ? 'rotate(180deg)' : 'none')};
    }
  }
`;

export const ListThreadsBody = styled.div``;

export const ThreadWrap = styled.div`
  font-size: 14px;
  margin-bottom: 30px;
  position: relative;
  overflow-y: hidden;

  &:after {
    top: 30px;
    left: 0;
    width: fit-content;
    height: calc(100% - 40px);
    content: '';
    position: absolute;
    border-left: 1px dashed #cecece;
  }

  .thread-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
    color: #868e96;

    .thread-fundname {
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .thread-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;
  }
`;

export const ThreadComments = styled.div`
  margin-left: 15px;
`;

export const CommentWrap = styled.div`
  font-size: 14px;
  position: relative;
  margin-bottom: 10px;

  //&:after {
  //  top: 10px;
  //  left: -100px;
  //  width: 98px;
  //  height: fit-content;
  //  content: '';
  //  position: absolute;
  //  border-top: 1px dashed #cecece;
  //}

  .comment-author {
    color: #228be6;
    font-weight: 500;
  }

  .comment-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #868e96;
    margin-bottom: 5px;

    button {
      height: 21px;
    }
  }

  .comment-text {
    color: #495057;
  }
`;

export const ThreadHighLightButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;
`;
